import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

// Analytics
import useAnalytics from '../../hooks/useAnalytics';

// Components
import AnimatedSection from '../../components/common/AnimatedSection';
import HeroSection from '../../components/home/HeroSection';
import AdvantagesSection from '../../components/home/AdvantagesSection';
import TestimonialsSection from '../../components/home/TestimonialsSection';
import TechStackSection from '../../components/home/TechStackSection';
import ProcessSection from '../../components/home/ProcessSection';
import CtaSection from '../../components/home/CtaSection';

const Home = () => {
  // Analytics hook
  const { trackCustomEvent } = useAnalytics();
  
  // Scroll to top on page load and track page view
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Track page view and Google Ads conversion
    trackCustomEvent('page_view', { page: 'home' });
    
    // Track with Google Ads conversion
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {'send_to': 'AW-17504442391'});
    }
  }, [trackCustomEvent]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Helmet>
        <title>Nexlyx | Développement Web sur Mesure à Meyreuil</title>
        <meta name="description" content="Nexlyx - Agence de développement web à Meyreuil. Création de sites vitrines, refonte de sites existants, optimisation SEO et maintenance web." />
        <meta name="keywords" content="développement web, création site internet, site vitrine, refonte site web, SEO, Meyreuil, PACA" />
        <meta property="og:title" content="Nexlyx | Développement Web sur Mesure" />
        <meta property="og:description" content="Agence de développement web à Meyreuil. Création de sites vitrines, refonte de sites existants, optimisation SEO et maintenance web." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://nexlyx.fr" />
        <meta property="og:image" content="https://nexlyx.fr/img/nexlyx-preview.jpg" />
        <link rel="canonical" href="https://nexlyx.fr" />
        <link rel="alternate" hrefLang="fr-FR" href="https://nexlyx.fr" />
      </Helmet>

      <main>
        <HeroSection />
        <AdvantagesSection />
        <TestimonialsSection />
        <TechStackSection />
        <ProcessSection />
        <CtaSection />
      </main>
    </motion.div>
  );
};

export default Home;
